export default "__VITE_ASSET__Bf51OuqH__"